import { SupaBaseAuth } from "./supabaseAbstract";
import {createClient, SupabaseClient} from "@supabase/supabase-js";
export function createSupabaseClient(supaBaseURL:string,supaBaseKey:string):SupabaseClient {
    const supabase = createClient(supaBaseURL, supaBaseKey);
    return supabase
}
export function getSupabaseAuth(supabase:SupabaseClient) {

    return new SupaBaseAuth("supabase",supabase);
}